import React from 'react';
// @ts-ignore
import PrismicDOM from 'prismic-dom';
import * as T from './types';
import * as S from './styles';
import { PrismicRichContent } from '../../../../../types';

export type RichTextProps = {
  data?: Array<PrismicRichContent>;
  container?: React.ElementType;
  linkResolver?: T.LinkResolver;
  serializer?: T.Serializer;
  className?: string;
};

const RichText = ({
  data,
  linkResolver,
  serializer,
  container,
  className,
}: RichTextProps) => {
  if (!Array.isArray(data) || !data.length) {
    return null;
  }

  const html = PrismicDOM.RichText.asHtml(
    data as any,
    linkResolver,
    serializer
  );

  const Component = container || S.RichTextSection;

  return (
    <Component
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export const plainText = (data: Array<PrismicRichContent>) => {
  return PrismicDOM.RichText.asText(data as any) ?? '';
};

export default RichText;
